<script lang="ts">import { goto } from "$app/navigation";
import { page } from "$app/stores";
import ToggleAlternative4 from "../icons/toggle-alternative4.svelte";
import { stateUi } from "@infinitro/config";
import { t } from "@infinitro/content";
import { getIsCollapsedFOMOBets, isBetbyDisplayed, isFullScreenGame, isPlayerChatOpen, loggedIn, ModalDialog, selectedItemMobileMenu, stateOpenModal, stateShowSidebarMobile, toSiteUrl } from "@infinitro/global";
import { LocalIcon, RemoteIcon } from "@infinitro/icons";
import FomoBetIcon from "./fomo-bet-icon.svelte";
export let menuItem;
export let onClickMenu = () => null;
export let onClickChat = () => null;
export let onClickSearch = () => null;
export let showFullScreenOnChatSlot = false;
export let isMenuCollapsed = false;
let active = false;
let href = "";
const isCollapsedFOMOBets$ = getIsCollapsedFOMOBets();
$: {
	const isMenuOpen = $stateShowSidebarMobile;
	const isChatOpen = !showFullScreenOnChatSlot && $isPlayerChatOpen;
	const hasOverlayActive = isMenuOpen || isChatOpen;
	if (menuItem.key !== "menu" && menuItem.key !== "chat") {
		href = toSiteUrl(menuItem.href, $loggedIn);
		const selectedNavigationItem = $selectedItemMobileMenu === "sports" || $selectedItemMobileMenu === "promo" || $selectedItemMobileMenu === "casino" ? $selectedItemMobileMenu : null;
		const isRouteActive = href === $page.url.pathname || menuItem.key === "sports" && $page.url.pathname.includes("/sports/") || menuItem.key === "casino" && $page.url.pathname.includes("/casino/") || menuItem.key === "fomo-points" && $page.url.pathname.includes("/tournaments/") || menuItem.key === "promo" && $page.url.pathname.includes("promotion") || menuItem.key === "special-bets" && $page.url.pathname.includes("/special-bets/") || menuItem.key === "luna-special-bets" && $page.url.pathname.includes("/special-bets/") || menuItem.key === "turbo-bets" && $page.url.pathname.includes("/special-bets/") || menuItem.key === "jackpot" && $page.url.pathname.includes("/promotion-page/jackpot/");
		active = !hasOverlayActive && (selectedNavigationItem ? selectedNavigationItem === menuItem.key : isRouteActive);
	} else {
		if (menuItem.key === "menu") {
			active = isMenuOpen;
		} else if (menuItem.key === "chat") {
			active = isChatOpen;
		}
	}
}
const sportsClick = (e) => {
	e.preventDefault();
	e.stopPropagation();
	stateShowSidebarMobile.set(false);
	const href = toSiteUrl("/sports/", $loggedIn);
	if ($isBetbyDisplayed) {} else {
		goto(href);
	}
	return false;
};
const rewardsClick = (e) => {
	e.preventDefault();
	e.stopPropagation();
	stateOpenModal.set(ModalDialog.RewardsDropdown);
	return false;
};
const blurActiveEditable = () => {
	const activeElement = document.activeElement;
	if (!(activeElement instanceof HTMLElement)) return;
	const tag = activeElement.tagName;
	const isEditable = activeElement.isContentEditable || tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";
	if (isEditable) activeElement.blur();
};
function handleClick(e) {
	const itemKey = menuItem.key ?? "";
	if (menuItem.key === "menu") {
		blurActiveEditable();
	}
	if ([
		"menu",
		"sports",
		"promo",
		"casino",
		"chat"
	].includes(itemKey)) {
		selectedItemMobileMenu.set(itemKey);
	}
	if (menuItem.key !== "chat" && menuItem.key !== "menu") {
		isPlayerChatOpen.set(false);
	}
	if (menuItem.key !== "menu") {
		stateShowSidebarMobile.set(false);
	}
	switch (menuItem.key) {
		case "sports":
			sportsClick(e);
			break;
		case "menu":
			onClickMenu();
			break;
		case "chat":
			onClickChat();
			break;
		case "search":
			onClickSearch();
			break;
		case "rewards":
			rewardsClick(e);
			break;
		default: break;
	}
}
$: useAlternative = $stateUi.mobileMenu.mobileMenuStyle === "alternative";
$: useAlternative2 = $stateUi.mobileMenu.mobileMenuStyle === "alternative2";
$: useAlternative4 = $stateUi.mobileMenu.mobileMenuStyle === "alternative4";
$: useMenuItemIndicator = $stateUi.mobileMenu.useMenuItemIndicator === true;
$: customColor = active ? "white" : "#FFFFFF99";
const iconSize = useAlternative4 ? 18 : 20;
</script>

{#if menuItem.key === 'menu' || menuItem.key === 'chat'}
	<button class="item-link" on:click={handleClick}>
		<div class="item {active ? 'active' : ''}">
			<div
				class:indicator={useMenuItemIndicator && active && !useAlternative2 && !useAlternative}
			></div>
			<span class="icon">
				{#if useAlternative4}
					<div style="color: {customColor}">
						<ToggleAlternative4 {active} />
					</div>
				{:else}
					<RemoteIcon
						icon={menuItem.icon ?? ''}
						size={iconSize}
						{active}
						color={useAlternative || useAlternative2 ? customColor : null}
					/>
				{/if}
			</span>
			{#if !isMenuCollapsed}
				<span
					class="text {active ? 'active' : ''}"
					class:text-alternative={useAlternative}
					class:text-alternative4={useAlternative4}
					class:active-alternative={useAlternative && active}
					class:active-alternative2={useAlternative2 && active}
					class:active-alternative4={useAlternative4 && active}
				>
					{$t(menuItem.name)}
				</span>
			{/if}
		</div>
	</button>
{:else if menuItem.key === 'special-bets' && useAlternative}
	<a {href} class="item-link" class:item-link-alternative={useAlternative} on:click={handleClick}>
		<div class="special-bets-icon" class:collapsed-special-bets-icon={$isCollapsedFOMOBets$}>
			<FomoBetIcon />
		</div>
		<div class="item {active ? 'active' : ''}">
			<div
				class:indicator={useMenuItemIndicator && active && !useAlternative2 && !useAlternative}
			></div>
			{#if !isMenuCollapsed}
				<span
					class="text {active ? 'active' : ''}"
					class:text-alternative={useAlternative}
					class:text-alternative4={useAlternative4}
					class:active-alternative={useAlternative && active}
					class:active-alternative2={useAlternative2 && active}
					class:active-alternative4={useAlternative4 && active}
				>
					{@html $t(menuItem.name)}
				</span>
			{/if}
		</div>
	</a>
{:else}
	<a {href} class="item-link" on:click={handleClick}>
		<div class="item {active ? 'active' : ''}">
			<div
				class:indicator={useMenuItemIndicator && active}
				class:indicator-alternative={active && useAlternative}
				class:indicator-alternative-2={active && useAlternative2}
			></div>
			<span class="icon">
				{#if useAlternative4}
					<div style="color: {customColor}">
						<LocalIcon icon={menuItem.icon ?? ''} size={iconSize} />
					</div>
				{:else}
					<RemoteIcon
						icon={menuItem.icon ?? ''}
						size={iconSize}
						{active}
						color={useAlternative || useAlternative2 ? customColor : null}
					/>
				{/if}
			</span>
			{#if !isMenuCollapsed}
				<span
					class="text {active ? 'active' : ''}"
					class:text-alternative={useAlternative}
					class:text-alternative4={useAlternative4}
					class:active-alternative={useAlternative && active}
					class:active-alternative2={useAlternative2 && active}
					class:active-alternative4={useAlternative4 && active}
				>
					{$t(menuItem.name)}
				</span>
			{/if}
		</div>
	</a>
{/if}

<style>
	.special-bets-icon {
		position: absolute;
		bottom: -14px;
		left: 50%;
		height: 5rem;
		width: 5rem;
		--tw-translate-x: -50%;
		--tw-translate-y: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		transition-property: bottom;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 300ms
}
	.collapsed-special-bets-icon {
		bottom: -48px;
		z-index: 50
}
	.item-link {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: center;
		background-color: transparent;
		font-size: 1rem;
		line-height: 1.5rem;
		font-family: var(--font-main)
}
	.item-link:hover {
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
	.item-link {

		&.disabled {
				pointer-events: none
		}

		&.disabled {
				cursor: not-allowed
		}

		&.disabled {
				opacity: 0.5
		}
	}

	.item-link-alternative {
		position: relative
}

	.item {
		position: relative;
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		&.disabled {
				cursor: not-allowed
		}

		&.disabled {
				--tw-text-opacity: 1;
				color: rgb(156 163 175 / var(--tw-text-opacity, 1))
		}
}

	.indicator {
		position: absolute;
		top: -5px;
		height: 3px;
		width: 65%;
		border-bottom-right-radius: 0.5rem;
		border-bottom-left-radius: 0.5rem;
		background: var(--gradient-primary);
		box-shadow: 0 0 3px 1px color-mix(in srgb, var(--color-primary-100) 20%, transparent)
}

	.icon {
		margin-top: 0.25rem;
		margin-bottom: 0.25rem;
		display: flex;
		align-items: center;
		justify-content: center
}

	.text {
		height: 1rem;
		white-space: nowrap;
		font-size: 10px;
		font-weight: 600;
		line-height: .75rem;
		letter-spacing: 1px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));

		&.disabled {
				--tw-text-opacity: 1;
				color: rgb(156 163 175 / var(--tw-text-opacity, 1))
		}
}

	.text-alternative {
		text-align: center;
		font-size: 12px;
		font-weight: 400;
		color: var(--color-text-700);
		height: unset
}

	.text-alternative4 {
		color: var(--color-text-100);
		opacity: 0.6
}

	.active {
		color: var(--color-primary-500)
}
	.active-alternative {
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
	.active-alternative2 {
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
	.active-alternative4 {
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		opacity: unset
}
</style>
